import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Plyr from "plyr-react";
import "plyr-react/plyr.css";
import { searchFilesByModule } from "../../services/FilesService/FilesService";
import toast from "react-hot-toast";
import SimpleLoader from "../../components/Loader/SimpleLoader";
import { ArrowLeftIcon } from "@heroicons/react/24/solid";

const extractYoutubeId = (url) => {
  const match = url?.match(/(?:youtu\.be\/|v=)([a-zA-Z0-9_-]{11})/);
  return match ? match[1] : null;
};

const ErkinOiynDetail = () => {
  const { uuid } = useParams();
  const navigate = useNavigate();
  const [video, setVideo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchVideo = async () => {
      try {
        const res = await searchFilesByModule({ module_code: "erkin_oiyn" });
        const match = res?.files?.find((v) => v.uuid === uuid);
        if (!match) {
          toast.error("Видео табылмады.");
        }
        setVideo(match || null);
      } catch (err) {
        toast.error("Қате орын алды.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchVideo();
  }, [uuid]);

  const videoId = extractYoutubeId(video?.link);

  if (loading) {
    return (
      <div className="flex justify-center items-center py-20">
        <SimpleLoader className="w-10 h-10 text-[#674da2]" />
      </div>
    );
  }

  if (!video || !videoId) {
    return (
      <div className="text-center text-red-500 mt-10">
        Видео табылмады немесе сілтеме дұрыс емес.
      </div>
    );
  }

  return (
    <div className="p-4 max-w-4xl mx-auto">
      <button
        onClick={() => navigate("/erkin_oiyn")}
        className="flex items-center text-[#674da2] mb-4 hover:underline"
      >
        <ArrowLeftIcon className="w-5 h-5 mr-1" />
        Артқа
      </button>
      <h1 className="text-2xl font-bold mb-4 text-center text-[#674da2]">
        {video.label}
      </h1>
      <div className="w-full sm:h-40 md:h-96 aspect-video">
        <Plyr
          source={{
            type: "video",
            sources: [
              {
                src: videoId,
                provider: "youtube",
              },
            ],
          }}
        />
      </div>
    </div>
  );
};

export default ErkinOiynDetail;
